module.exports = __webpack_public_path__ + "static/kartrace-logo-3870c32f55669adb19129047e02a6988.jpg";